import { reflectKeys } from "@utils/key.reflactor.ts";

export const NAMESPACE = {
  APP: "app",
  AUTH: "auth",
  CONTENT_MASTERY: "content.mastery",
};

export const QUERY_PARAM = {
  GROUP: "group", //groupUuid
  SUBJECT: "subject", //subjectId
  LEVEL: "level", //levelAndStreamId
  SYLLABUS: "syllabus", //syllabusId
  YEAR: "year", //academic year
  TAB: "tab", //selected tab
  SELECTED_OPTION: "selected", // [assignment, self-study, all]
  USER: "user", // userId of student when in teacher student view
  TEACHER_GROUP: "teacherGroup", // teacher's group selection when in teacher view
};

export const TAB_OPTIONS = {
  ASSIGNMENT_SELF_STUDY: "assignment-self-study",
  ALS: "als",
  AREAS_FOR_IMPROVEMENT: "areas-for-improvement",
};

export const CLASS_GROUP_CATEGORY_TYPES = {
  // IMPORTANT: ORDER OF THE PROPERTIES WILL AFFECT THE SEQUENCE IN THE DROPDOWN SELECTION
  PINNED_TAGGED_GROUP: "pinned-tagged-group",
  UNPINNED_TAGGED_GROUP: "unpinned-tagged-group",
  PINNED_UNTAGGED_GROUP: "pinned-untagged-group",
  UNPINNED_UNTAGGED_GROUP: "unpinned-untagged-group",
  PAST_TAGGED_GROUP: "past-tagged-group",
  PAST_UNTAGGED_GROUP: "past-untagged-group",
};

export const INCLUDE_OPTIONS = {
  ASSIGNMENT: "assignment",
  SELF_STUDY: "self-study",
  ALL: "all",
};

export const VIEW_TYPE_TAB_OPTIONS = {
  TOPICAL: 0,
  MONTHLY: 1,
  STUDENT: 2,
  QUESTIONS: 2,
};

export const VIEW_TYPE_TAB_OPTIONS_ALS = {
  TOPICAL: 0,
  STUDENT: 1,
};

export const FILTER_OPTIONS = {
  MONTH_RANGE: "monthRange",
  TOPIC: "topic",
  ERROR_TAG: "errorTag",
};

export const SCALE_OPTIONS = {
  REMAINING_MARK: "Remaining Mark",
  SDL_SCORE: "SDL Score",
  ASSIGNMENT_SCORE: "Assignment Score",
};

export const BAR_CHART_OPTIONS = {
  MIN_HEIGHT: 100,
  BAR_HEIGHT: 40,
  OPTION_HEIGHT: 60,
  DEFAULT_CHART_TICKS: 11,
};

export const BAR_CHART_GROUPED_LABEL = {
  SDL_SCORE: "SdlScore",
  ASSIGNMENT_SCORE: "AssignmentScore",
  REMAINING_MARK: "RemainingMark",
};

export const BAR_CHART_GROUPED_COLOR = {
  SDL_SCORE: "#aac1f0",
  REMAINING_MARK: "#e7e9ec",
};

export const SUBPAGE_TYPE = reflectKeys(["UNTAGGED", "TAGGED", "EXCLUDED"]);

export const SUBGROUP_NAME_CHARACTER_LIMIT = 50;

export const QUESTION_TYPE = reflectKeys([
  "MCQ",
  "MRQ",
  "MPQ",
  "REC",
  "FREE",
  "FILE",
  "FILL",
  "DND",
  "EEQ",
]);

export const RESOURCE_STATUS = reflectKeys(["APPROVED", "DRAFT"]);

export const RESOURCE_TYPE = reflectKeys(["LESSON", "ASSIGNMENT"]);

export const RESOURCE_DOMAIN = {
  MOE: "MOE",
  COMMUNITY: "COMMUNITY",
  PERSONAL: "PERSONAL",
  ALP_TEMPLATE: "ALP_TEMPLATE",
  ASSIGNMENT: "ASSIGNMENT",
};

export const COMPONENT_TYPE = {
  ACCORDION: "CONTAINER_ACCORDION",
  TWO_COLUMN: "CONTAINER_TWO_COLUMN",
  THREE_COLUMN: "CONTAINER_THREE_COLUMN",
  QUESTION: "COMPONENT_QUESTION",
  TEXT: "COMPONENT_RICHTEXT",
  YOUTUBE: "COMPONENT_YOUTUBE",
  MO: "COMPONENT_MEDIAOBJECT",
  POLL: "COMPONENT_POLL",
};

export const STUDENT_GROUP_STATUS = reflectKeys(["ACTIVE", "INACTIVE"]);

export const MAX_STUDENT_SIZE = 100;

export const SELF_STUDY_COLOR = "#aac1f0";

export const NO_OF_YEARS = 4;

export const MAX_SELECTED_CLASS_GROUP_SIZE = 10;
